import { QuestionStatus } from './enums';

/** A root waiting for enrichment, or past it and neither retired nor replaced. */
export const ENRICHABLE_QUESTION_STATUSES: readonly QuestionStatus[] = [
  QuestionStatus.ReadyForEnrichment,
  QuestionStatus.AwaitingReview,
  QuestionStatus.Published,
];

/** The range a question's computed difficulty falls in, out of 10. */
export const QUESTION_DIFFICULTY_MIN = 1;
export const QUESTION_DIFFICULTY_MAX = 10;
